<template>
  <div class="AppointmentFamilyModal">
    <btn @click.native="getData"><i class="fa fa-user-plus"></i>家庭の追加</btn>
    <component-modal v-show="condition.condition" transition="expand">
      <template slot="title">家庭登録</template>
      <div slot="body">
        <table class="m-table">
          <tbody>
            <tr>
              <th>名前</th>
              <td>
                <input class="half" type='text' v-model="family.f_name" placeholder="姓"><input class="half" type='text' v-model="family.l_name" placeholder="名">
              </td>
            </tr>
            <tr>
              <th class="req">かな</th>
              <td>
                <input class="half" type='text' v-model="family.f_name_kana" placeholder="せい"><input class="half" type='text' v-model="family.l_name_kana" placeholder="めい">
              </td>
            </tr>
            <tr>
              <th>続柄</th>
              <td><multiselect @select="select" v-model="watch.relationship" :options="relationship" label="name" :show-labels="false" placeholder="続柄"></multiselect></td>
            </tr>
            <tr>
              <th>郵便番号</th>
              <td><input type='text' v-model="family.zip" placeholder="郵便番号" @keyup="getYubin"></td>
            </tr>
            <tr>
              <th class="req">都道府県</th>
              <td><multiselect @select="select" v-model="watch.pref" :options="pref" label="name" :show-labels="false" placeholder="都道府県"></multiselect></td>
            </tr>
            <tr>
              <th class="req">住所(市区町村・番地)</th>
              <td><input type='text' v-model="family.address1" placeholder="住所1"></td>
            </tr>
            <tr>
              <th class="req">住所(建物名・部屋番号)</th>
              <td><input type='text' v-model="family.address2" placeholder="住所2"></td>
            </tr>
            <tr>
              <th class="req">TEL1</th>
              <td><input type='text' v-model="family.tel1" placeholder="TEL1"></td>
            </tr>
            <tr>
              <th>TEL2</th>
              <td><input type='text' v-model="family.tel2" placeholder="TEL2"></td>
            </tr>
            <tr>
              <th>FAX</th>
              <td><input type='text' v-model="family.fax" placeholder="FAX"></td>
            </tr>
            <tr>
              <th>MAIL1</th>
              <td><input type='text' v-model="family.mail" placeholder="MAIL1"></td>
            </tr>
            <tr>
              <th>MAIL2</th>
              <td><input type='text' v-model="family.mail2" placeholder="MAIL2"></td>
            </tr>
            <tr>
              <th>指導種類</th>
              <td><multiselect @select="select" v-model="watch.guidance_type" :options="guidance_type" label="name" :show-labels="false" placeholder="指導種類"></multiselect></td>
            </tr>
            <tr>
              <th>家族構成</th>
              <td><input type='text' v-model="family.structure" placeholder="家族構成"></td>
            </tr>
            <tr>
              <th>件口</th>
              <td><multiselect @select="select" v-model="watch.unit" :options="unit" label="name" :show-labels="false" placeholder="件口"></multiselect></td>
            </tr>
            <tr>
              <th>勤務先TEL</th>
              <td><input type='text' v-model="family.workplace_contact" placeholder="勤務先TEL"></td>
            </tr>
            <tr>
              <th class="req">優先連絡先</th>
              <td><multiselect @select="select" v-model="watch.preferred_contact" :options="preferred_contact" label="name" :show-labels="false" placeholder="優先連絡先"></multiselect></td>
            </tr>
            <tr>
              <th>連絡曜日時間帯</th>
              <td><input type='text' v-model="family.contact_timezone" placeholder="連絡曜日時間帯"></td>
            </tr>
            <tr>
              <th>退会日</th>
              <td><input type='text' v-model="family.withdrawal_date" placeholder="退会日"></td>
            </tr>
            <tr>
              <th>備考1</th>
              <td><textarea v-model="family.note1" placeholder="備考1"></textarea></td>
            </tr>
            <tr>
              <th>備考2</th>
              <td><textarea v-model="family.note2" placeholder="備考2"></textarea></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="footer" slot="footer">
        <btn @click.native="postFamilyModal">登録</btn>
        <btn @click.native="showModal">キャンセル</btn>
      </div>
    </component-modal>
  </div>
</template>

<script>
let jsonp = require('jsonp')
export default {
  props: {
    appointment: Object
  },
  computed: {
    // 算出 getter 関数
    appointment_id () {
      // `this` は vm インスタンスを指します
      return this.$store.state.item.appointment.id
    }
  },
  name: 'FamilyStudentsModal',
  data () {
    return {
      dtp: {
        // date: '',
        date: new Date(),
        format: 'yyyy/MM/dd',
        format2: 'yyyy/MM',
        disabled: {
          // to: new Date(2000, 4, 1)
          // from: new Date(2000, 4, 1)
          // days: [6, 0]
          // dates: [
          //   new Date(2017, 9, 16),
          //   new Date(2017, 9, 17),
          //   new Date(2017, 9, 18)
          // ]
        }
      },

      condition: {
        condition: false
      },

      family: {
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        relationship: 0,
        pref: 0,
        geometry: '',
        zip: '',
        address1: '',
        address2: '',
        tel1: '',
        tel2: '',
        fax: '',
        mail: '',
        mail2: '',
        guidance_type: 0,
        structure: '',
        unit: 0,
        workplace_contact: '',
        preferred_contact: 0,
        contact_timezone: '',
        withdrawal_date: '',
        note1: '',
        note2: ''
      },

      watch: {
        relationship: '',
        pref: '',
        guidance_type: '',
        unit: '',
        preferred_contact: ''
      },

      relationship: [
        { name: '未選択', value: 0 },
        { name: '母', value: 1 },
        { name: '父', value: 2 },
        { name: '祖母', value: 3 },
        { name: '祖父', value: 4 },
        { name: '本人', value: 5 }
      ],

      pref: [
        { name: '未選択', value: 0 },
        { name: '北海道', value: 1 },
        { name: '青森県', value: 2 },
        { name: '秋田県', value: 3 },
        { name: '岩手県', value: 4 },
        { name: '山形県', value: 5 },
        { name: '宮城県', value: 6 },
        { name: '福島県', value: 7 },
        { name: '栃木県', value: 8 },
        { name: '山梨県', value: 9 },
        { name: '群馬県', value: 10 },
        { name: '茨城県', value: 11 },
        { name: '千葉県', value: 12 },
        { name: '埼玉県', value: 13 },
        { name: '東京都', value: 14 },
        { name: '神奈川県', value: 15 },
        { name: '静岡県', value: 16 },
        { name: '長野県', value: 17 },
        { name: '愛知県', value: 18 },
        { name: '岐阜県', value: 19 },
        { name: '新潟県', value: 20 },
        { name: '富山県', value: 21 },
        { name: '石川県', value: 22 },
        { name: '福井県', value: 23 },
        { name: '滋賀県', value: 24 },
        { name: '京都府', value: 25 },
        { name: '三重県', value: 26 },
        { name: '和歌山県', value: 27 },
        { name: '奈良県', value: 28 },
        { name: '大阪府', value: 29 },
        { name: '兵庫県', value: 30 },
        { name: '鳥取県', value: 31 },
        { name: '島根県', value: 32 },
        { name: '岡山県', value: 33 },
        { name: '広島県', value: 34 },
        { name: '山口県', value: 35 },
        { name: '高知県', value: 36 },
        { name: '徳島県', value: 37 },
        { name: '香川県', value: 38 },
        { name: '愛媛県', value: 39 },
        { name: '福岡県', value: 40 },
        { name: '佐賀県', value: 41 },
        { name: '長崎県', value: 42 },
        { name: '熊本県', value: 43 },
        { name: '宮崎県', value: 44 },
        { name: '大分県', value: 45 },
        { name: '鹿児島県', value: 46 },
        { name: '沖縄県', value: 47 }
      ],

      guidance_type: [
        { name: '未選択', value: 0 },
        { name: '1人指導', value: 1 },
        { name: '2人同時指導', value: 2 },
        { name: '3人同時指導', value: 3 }
      ],

      unit: [
        { name: '未選択', value: 0 },
        { name: '1件口', value: 1 },
        { name: '2件口', value: 2 },
        { name: '3件口', value: 3 }
      ],

      preferred_contact: [
        { name: '未選択', value: 0 },
        { name: '自宅', value: 1 },
        { name: '携帯', value: 2 },
        { name: '勤務先', value: 3 },
        { name: 'その他', value: 4 }
      ]
    }
  },
  watch: {
    'watch.relationship': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.relationship = now.value
      } else {
        this.family.relationship = ''
      }
    },

    'watch.pref': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.pref = now.value
        this.family.geometry = now.name
      } else {
        this.family.pref = ''
      }
    },

    'watch.guidance_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.guidance_type = now.value
      } else {
        this.family.guidance_type = ''
      }
    },

    'watch.unit': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.unit = now.value
      } else {
        this.family.unit_type = ''
      }
    },

    'watch.preferred_contact': function (now, old) {
      // console.log(now)
      if (now) {
        this.family.preferred_contact = now.value
      } else {
        this.family.preferred_contact = ''
      }
    }
  },
  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
      // console.log(selectedOption.name)
      // console.log(selectedOption.value)
    },

    showModal () {
      this.condition.condition = !this.condition.condition
    },

    getData () {
      this.condition.condition = !this.condition.condition
      this.family.f_name = this.appointment.f_name
      this.family.f_name_kana = this.appointment.f_name_kana
      this.family.zip = this.appointment.zip
      this.family.pref = this.appointment.pref
      this.watch.pref = this.pref[this.appointment.pref]
      this.family.address1 = this.appointment.address1
      this.family.address2 = this.appointment.address2
      this.family.tel1 = this.appointment.tel1
      this.family.tel2 = this.appointment.tel2
      this.family.fax = this.appointment.fax
      this.family.mail = this.appointment.mail
    },

    getYubin (e) {
      let that = this
      // console.log(e)
      const value = e.target.value
      if (value.length > 5) {
        jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
          if (err) {
            // error
            console.error(err.message)
          } else {
            // success
            // console.log(data)
            if (data.results[0].address1 === '北海道') {
              that.watch.pref = { name: '北海道', value: 1 }
            } else if (data.results[0].address1 === '青森県') {
              that.watch.pref = { name: '青森県', value: 2 }
            } else if (data.results[0].address1 === '秋田県') {
              that.watch.pref = { name: '秋田県', value: 3 }
            } else if (data.results[0].address1 === '岩手県') {
              that.watch.pref = { name: '岩手県', value: 4 }
            } else if (data.results[0].address1 === '山形県') {
              that.watch.pref = { name: '山形県', value: 5 }
            } else if (data.results[0].address1 === '宮城県') {
              that.watch.pref = { name: '宮城県', value: 6 }
            } else if (data.results[0].address1 === '福島県') {
              that.watch.pref = { name: '福島県', value: 7 }
            } else if (data.results[0].address1 === '栃木県') {
              that.watch.pref = { name: '栃木県', value: 8 }
            } else if (data.results[0].address1 === '山梨県') {
              that.watch.pref = { name: '山梨県', value: 9 }
            } else if (data.results[0].address1 === '群馬県') {
              that.watch.pref = { name: '群馬県', value: 10 }
            } else if (data.results[0].address1 === '茨城県') {
              that.watch.pref = { name: '茨城県', value: 11 }
            } else if (data.results[0].address1 === '千葉県') {
              that.watch.pref = { name: '千葉県', value: 12 }
            } else if (data.results[0].address1 === '埼玉県') {
              that.watch.pref = { name: '埼玉県', value: 13 }
            } else if (data.results[0].address1 === '東京都') {
              that.watch.pref = { name: '東京都', value: 14 }
            } else if (data.results[0].address1 === '神奈川県') {
              that.watch.pref = { name: '神奈川県', value: 15 }
            } else if (data.results[0].address1 === '静岡県') {
              that.watch.pref = { name: '静岡県', value: 16 }
            } else if (data.results[0].address1 === '長野県') {
              that.watch.pref = { name: '長野県', value: 17 }
            } else if (data.results[0].address1 === '愛知県') {
              that.watch.pref = { name: '愛知県', value: 18 }
            } else if (data.results[0].address1 === '岐阜県') {
              that.watch.pref = { name: '岐阜県', value: 19 }
            } else if (data.results[0].address1 === '新潟県') {
              that.watch.pref = { name: '新潟県', value: 20 }
            } else if (data.results[0].address1 === '富山県') {
              that.watch.pref = { name: '富山県', value: 21 }
            } else if (data.results[0].address1 === '石川県') {
              that.watch.pref = { name: '石川県', value: 22 }
            } else if (data.results[0].address1 === '福井県') {
              that.watch.pref = { name: '福井県', value: 23 }
            } else if (data.results[0].address1 === '滋賀県') {
              that.watch.pref = { name: '滋賀県', value: 24 }
            } else if (data.results[0].address1 === '京都府') {
              that.watch.pref = { name: '京都府', value: 25 }
            } else if (data.results[0].address1 === '三重県') {
              that.watch.pref = { name: '三重県', value: 26 }
            } else if (data.results[0].address1 === '和歌山県') {
              that.watch.pref = { name: '和歌山県', value: 27 }
            } else if (data.results[0].address1 === '奈良県') {
              that.watch.pref = { name: '奈良県', value: 28 }
            } else if (data.results[0].address1 === '大阪府') {
              that.watch.pref = { name: '大阪府', value: 29 }
            } else if (data.results[0].address1 === '兵庫県') {
              that.watch.pref = { name: '兵庫県', value: 30 }
            } else if (data.results[0].address1 === '鳥取県') {
              that.watch.pref = { name: '鳥取県', value: 31 }
            } else if (data.results[0].address1 === '島根県') {
              that.watch.pref = { name: '島根県', value: 32 }
            } else if (data.results[0].address1 === '岡山県') {
              that.watch.pref = { name: '岡山県', value: 33 }
            } else if (data.results[0].address1 === '広島県') {
              that.watch.pref = { name: '広島県', value: 34 }
            } else if (data.results[0].address1 === '山口県') {
              that.watch.pref = { name: '山口県', value: 35 }
            } else if (data.results[0].address1 === '高知県') {
              that.watch.pref = { name: '高知県', value: 36 }
            } else if (data.results[0].address1 === '徳島県') {
              that.watch.pref = { name: '徳島県', value: 37 }
            } else if (data.results[0].address1 === '香川県') {
              that.watch.pref = { name: '香川県', value: 38 }
            } else if (data.results[0].address1 === '愛媛県') {
              that.watch.pref = { name: '愛媛県', value: 39 }
            } else if (data.results[0].address1 === '福岡県') {
              that.watch.pref = { name: '福岡県', value: 40 }
            } else if (data.results[0].address1 === '佐賀県') {
              that.watch.pref = { name: '佐賀県', value: 41 }
            } else if (data.results[0].address1 === '長崎県') {
              that.watch.pref = { name: '長崎県', value: 42 }
            } else if (data.results[0].address1 === '熊本県') {
              that.watch.pref = { name: '熊本県', value: 43 }
            } else if (data.results[0].address1 === '宮崎県') {
              that.watch.pref = { name: '宮崎県', value: 44 }
            } else if (data.results[0].address1 === '大分県') {
              that.watch.pref = { name: '大分県', value: 45 }
            } else if (data.results[0].address1 === '鹿児島県') {
              that.watch.pref = { name: '鹿児島県', value: 46 }
            } else if (data.results[0].address1 === '沖縄県') {
              that.watch.pref = { name: '沖縄県', value: 47 }
            }
            that.family.address1 = data.results[0].address2 + data.results[0].address3
          }
        })
      }
    },
    postFamilyModal () {
      this.$store.dispatch('postFamilyModal', {
        appointment: this.appointment,
        family: this.family,
        condition: this.condition
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang='scss' scoped>
.req {
  background: #dffbef;
}
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
table {
  border-spacing: 0;
  width: 100%;
  tr {
    th {
      border-bottom: solid 1px #ddd;
      background: #f4f4f4;
      color: #333;
      padding: 10px;
    }
    td {
      border-bottom: solid 1px #ddd;
      input {
        outline: 0;
        border: none;
        width: 100%;
      }
      .half {
        width: 50%;
      }
      textarea {
        outline: 0;
        border: none;
        width: 100%;
      }
    }
  }
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
</style>
<style lang="scss">
.AppointmentFamilyModal {
  .multiselect__tags {
    border: 0;
  }
  .vdp-datepicker {
    input {
      height: 40px;
      border: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// AppointmentFamilyModal.vue?504128a8